import { Link } from "react-router-dom";
import { Reveal, MaskIn, MaskLine, SectionHead } from "@/components/motion";
import { LogoMark } from "@/components/LogoMark";

const TOPICS = [
    "Sustainability and ESG",
    "Corporate governance",
    "Regulation and compliance",
    "Business strategy",
    "Climate transition",
    "Leadership",
    "Organisational performance",
    "Sustainable finance",
    "Responsible business",
];

export default function Insights() {
    return (
        <div>
            <section
                className="mx-auto max-w-7xl px-6 pt-32 md:px-12 md:pt-44"
                data-testid="insights-hero"
            >
                <Reveal y={16}>
                    <p className="eyebrow text-ink/50">Insights</p>
                </Reveal>
                <h1 className="mt-8 max-w-5xl font-serif-d text-4xl leading-[1.1] sm:text-5xl md:text-7xl">
                    <MaskLine delay={0.2}>
                        Turning complex issues into
                    </MaskLine>
                    <MaskLine delay={0.32}>
                        <em className="italic text-brand">
                            practical perspectives
                        </em>
                        .
                    </MaskLine>
                </h1>
                <Reveal delay={0.2} className="mt-10 max-w-2xl">
                    <p className="text-[15px] leading-relaxed text-ink/60">
                        The business environment is evolving rapidly. Our
                        Insights platform explores the developments shaping
                        organisations today and turns complex issues into
                        practical perspectives for leaders and decision-makers.
                    </p>
                </Reveal>
            </section>

            <section
                className="mt-24 border-t border-black/10 md:mt-32"
                data-testid="insights-topics"
            >
                <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                    <SectionHead index="01" label="Topics we write about" />
                    <MaskIn className="mt-12 max-w-3xl">
                        <h2 className="font-serif-d text-4xl md:text-6xl">
                            The index.
                        </h2>
                    </MaskIn>
                    <div className="mt-14">
                        {TOPICS.map((t, i) => (
                            <Reveal key={t} delay={i * 0.04} y={20}>
                                <div
                                    className="group flex items-center justify-between border-t border-black/10 py-6 md:py-8"
                                    data-testid={`insights-topic-row-${i + 1}`}
                                >
                                    <div className="flex items-baseline gap-6 md:gap-10">
                                        <span className="font-mono2 text-xs text-brand">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <span className="row-bg font-serif-d text-xl transition-colors duration-300 group-hover:text-brand md:text-4xl">
                                            {t}
                                        </span>
                                    </div>
                                    <span className="arrow-shift text-xl text-ink/30 group-hover:text-brand">
                                        →
                                    </span>
                                </div>
                            </Reveal>
                        ))}
                        <div className="border-t border-black/10" />
                    </div>
                    <Reveal delay={0.2}>
                        <p
                            className="eyebrow mt-10 text-ink/40"
                            data-testid="insights-launch-note"
                        >
                            Full insight notes launch soon
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-brand text-white" data-testid="insights-cta">
                <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                    <Reveal>
                        <LogoMark variant="white" className="h-12 w-auto" />
                    </Reveal>
                    <MaskIn className="max-w-4xl">
                        <h2 className="font-serif-d text-4xl leading-tight md:text-6xl">
                            Have a question on one of these themes?
                        </h2>
                    </MaskIn>
                    <Reveal
                        delay={0.2}
                        className="mt-10 flex flex-wrap items-center gap-6"
                    >
                        <Link
                            to="/contact"
                            data-testid="insights-cta-contact"
                            className="rounded-full bg-white px-8 py-4 text-sm font-semibold text-ink transition-colors duration-300 hover:bg-brandsoft"
                        >
                            Start a Conversation
                        </Link>
                        <p className="text-sm text-white/60">
                            We would be pleased to discuss how ELCAYIL can
                            support you.
                        </p>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
